import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function AuthCallback() {
  const { googleSession } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sid = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    (async () => {
      const res = sid ? await googleSession(sid) : { ok: false, error: "Missing Google session" };
      if (res.ok) {
        toast.success("Signed in with Google");
        navigate(res.role === "landlord" ? "/dashboard" : "/portal", { replace: true });
      } else {
        toast.error(res.error || "Google sign-in failed");
        navigate("/login", { replace: true });
      }
    })();
  }, []); // eslint-disable-line

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-3 text-slate-500" data-testid="auth-callback">
      <Loader2 className="h-7 w-7 animate-spin text-primary" /> Finishing Google sign-in…
    </div>
  );
}
